import TechniqueDetailsPageContent from '@/components/pages/technique-details-page';

export default function TechniqueDetailsPage() {
  return <TechniqueDetailsPageContent />;
}
